// import React, { PureComponent } from "react";
// import { withRouter } from "react-router-dom";
// import PropTypes from "prop-types";
// import _ from "lodash";

// import IconButton from "./IconButton";
// import Close from "./icons/Close";

// import {
//   getParameterByName,
//   parameterToObject,
//   objectToParameter
// } from "../utils";

// @withRouter
// export default class Modal extends PureComponent {
//   static propTypes = {
//     children: PropTypes.node,
//     visible: PropTypes.bool,
//     onCancel: PropTypes.func,
//     className: PropTypes.string,
//     name: PropTypes.string
//   };

//   static defaultProps = {
//     children: null,
//     visible: false,
//     onCancel: () => null,
//     className: "",
//     name: ""
//   };

//   constructor(props) {
//     super(props);
//     this._popup = React.createRef();
//     this.state = { visible: props.visible };
//   }

//   componentDidMount() {
//     this.init(this.props.visible);
//     // if (this._popup.current) {
//     //   this._popup.current.style.height = window.innerHeight + "px"; // Fix iOS, Android -> calculate real window height;
//     //   window.addEventListener("resize", this.onResize);
//     // }
//   }

//   componentWillReceiveProps(nextProps) {
//     if (!_.isEqual(this.props.visible, nextProps.visible)) {
//       this.init(nextProps.visible);
//     }
//   }

//   // onResize = () => {
//   //   this._popup.current.style.height = window.innerHeight + "px";
//   // };

//   // componentWillUnmount() {
//   //   window.removeEventListener("resize", this.onResize);
//   // }

//   setVisible = visible => {
//     if (this.state.visible !== visible) {
//       this.setState({ visible });
//     }
//   };

//   setUrl = () => {
//     const { name } = this.props;
//     const paramObj = parameterToObject();
//     paramObj.modal = name;
//     const param = objectToParameter(paramObj);
//     this.props.history.push(`?${param}`);
//   };

//   init = visible => {
//     const { name } = this.props;
//     const modalParam = getParameterByName("modal");
//     if (modalParam === name) {
//       this.setVisible(true);
//       document.body.style.overflow = "hidden";
//     } else {
//       this.setVisible(visible);
//       if (visible) {
//         this.setUrl();
//         document.body.style.overflow = "hidden";
//       }
//     }
//   };

//   handleClickClose = () => {
//     this.setVisible(false);
//     this.props.onCancel();
//     setTimeout(() => {
//       const modalComponents = document.querySelectorAll(".modal-component");
//       let hasModalShow = false;
//       for (let index = 0; index < modalComponents.length; index++) {
//         const modalComponent = modalComponents[index];
//         if (modalComponent.classList.contains("open")) {
//           hasModalShow = true;
//           break;
//         }
//       }
//       if (hasModalShow) {
//         document.body.style.overflow = "hidden";
//       } else {
//         document.body.style.overflow = "auto";
//       }
//     }, 100);
//     if (document.referrer) {
//       this.props.history.goBack();
//     } else {
//       this.props.history.push(this.props.location.pathname);
//     }
//   };

//   getHtml = () => {
//     return (
//       <React.Fragment>
//         <div className="icon-close">
//           <IconButton onClick={this.handleClickClose}>
//             <Close width={20} height={20} fill="white" />
//           </IconButton>
//         </div>
//         {this.props.children}
//       </React.Fragment>
//     );
//   };

//   render() {
//     const { className } = this.props;
//     const { visible } = this.state;
//     return (
//       <div
//         ref={this._popup}
//         className={`modal-component ${className} ${visible ? "open" : ""}`}
//       >
//         {this.getHtml()}
//       </div>
//     );
//   }
// }

import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import _ from "lodash";

import IconButton from "./IconButton";
import Close from "./icons/Close";

// import {
//   getParameterByName,
//   parameterToObject,
//   objectToParameter
// } from "../utils";

export default class Modal extends Component {
  static propTypes = {
    children: PropTypes.node,
    onCancel: PropTypes.func,
    className: PropTypes.string
  };

  static defaultProps = {
    children: null,
    onCancel: () => null,
    className: ""
  };

  state = {
    // showModal: false
  };

  componentDidMount() {
    const { className } = this.props;
    // const modalParam = getParameterByName("modal");
    // if (modalParam === name) this.setState({ showModal: true });
    this._popup = document.createElement("div");
    this._popup.className = `modal-component ${className}`;
    document.body.appendChild(this._popup);
    this._render();
  }

  componentDidUpdate() {
    this._render();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this._popup);
    document.body.removeChild(this._popup);
  }

  // setUrl = () => {
  //   const { name } = this.props;
  //   const paramObj = parameterToObject();
  //   paramObj.modal = name;
  //   const param = objectToParameter(paramObj);
  //   window.history.pushState({}, null, `?${param}`);
  // };

  addClassName = (element, name) => {
    const arr = _.split(element.className, " ");
    if (!_.includes(arr, name)) {
      arr.push(name);
    }
    element.className = _.join(arr, " ");
  };

  removeClassName = (element, name) => {
    const arr = _.split(element.className, " ");
    if (_.includes(arr, name)) {
      _.remove(arr, value => value === name);
    }
    element.className = _.join(arr, " ");
  };

  setOverflow = overflow => {
    // document.documentElement.style.overflow = overflow; // this line cause hash to change
    document.body.style.overflow = overflow;
  };

  handleClickClose = () => {
    this.removeClassName(this._popup, "open");
    setTimeout(() => {
      this.props.onCancel();
      const modalComponents = document.querySelectorAll(".modal-component");
      let hasModalShow = false;
      for (let index = 0; index < modalComponents.length; index++) {
        const modalComponent = modalComponents[index];
        if (modalComponent.classList.contains("open")) {
          hasModalShow = true;
          break;
        }
      }
      if (hasModalShow) {
        this.setOverflow("hidden");
      } else {
        this.setOverflow("inherit");
      }
    }, 300);
    // if (document.referrer) {
    //   window.history.back();
    // } else {
    //   window.history.pushState({}, null, window.location.pathname);
    // }
  };

  getHtml = () => {
    return (
      <React.Fragment>
        <div className="icon-close">
          <IconButton onClick={this.handleClickClose}>
            <Close width={20} height={20} fill="white" />
          </IconButton>
        </div>
        {this.props.children}
      </React.Fragment>
    );
  };

  _render() {
    this.setOverflow("hidden");
    ReactDOM.render(this.getHtml(), this._popup);
    setTimeout(() => {
      this.addClassName(this._popup, "open");
    }, 200);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.js